import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';

import type { InterventionCenterStatistics as InterventionCenterStatisticsType } from '../../../common/types/statistics/fhbfStatistics';
import OptionStatistic from './OptionStatistic';
import onwardPlacementForm from '../../../clients/detail/fhbfForm/interventionCenter/onwardPlacementForm';

type Props = {
  statistics: InterventionCenterStatisticsType;
};

function ReferralStatistics({ statistics }: Props) {
  return (
    <Paper
      variant='outlined'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        margin: '24px 0',
        padding: '20px 24px',
        maxWidth: '650px',
        minWidth: '300px',
        backgroundColor: '#FAFAFA',
      }}
    >
      <Stack direction='column'>
        <Typography fontSize='1.2rem' fontWeight='bold' mb={2}>
          Weitervermittlung und Weiterempfehlung
        </Typography>
        <Typography>
          Davon direkte fallbezogene Kontaktaufnahme durch die IST zu anderer Einrichtung:{' '}
          {statistics.numberOfOnwardPlacementDirectContact}
        </Typography>
        <Typography>
          Davon nur Weitergabe der Kontaktdaten: {statistics.numberOfOnwardPlacementContactDetails}
        </Typography>
        <Typography>Beides: {statistics.numberOfBothOnwardPlacement}</Typography>
        <OptionStatistic
          fieldKey='onwardPlacement'
          fields={onwardPlacementForm.fields}
          statistic={statistics.onwardPlacement}
        />
      </Stack>
    </Paper>
  );
}

export default ReferralStatistics;
